import 'mapbox-gl/dist/mapbox-gl.css';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom';
import Provider from 'react-redux/es/components/Provider';
import { LocalizationProvider } from './i18n';
import { store } from './store';
import { App } from './App';
import './index.css';

ReactDOM.render(
    <StrictMode>
        <Provider store={store}>
            <LocalizationProvider>
                <App />
            </LocalizationProvider>
        </Provider>
    </StrictMode>,
    document.getElementById('root')
);
